import styled, { css, keyframes } from 'styled-components';
import { Text, DefaultTheme } from '@pinpoint/design-kit';

const Shake = keyframes`
  0%, 100% {
    left: 0px;
  }
  20%, 60% {
    left: 15px;
  }
  40%, 80% {
    left: -15px;
  }
`;

const ShakeAnimation = (props) =>
  props.shake
    ? css`
        ${Shake} 0.3s;
      `
    : 'none 0s;';

export default styled(Text)`
  position: relative;
  line-height: 1.25rem;
  color: ${DefaultTheme.colors.danger600};
  animation: ${ShakeAnimation};
`;
